import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import { api_url } from "../../apiUtils";

const ResultTable = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const result = sessionStorage.getItem("accesstoken");
  const headers = { accessToken: result };

  useEffect(() => {
    const fetchResults = async () => {
      try {
        const response = await axios.get(`${api_url}results/get-last-result`, {
          headers,
        });

        const results = response.data.results;

        if (results.length) {
          const formattedResults = results.map((result) =>
            createData(
              new Date(result.createdAt).toLocaleDateString("en-GB") || "-",
              result.gameId?.gameName || "-",
              result.result || "-",
              result.jodi || "-",
              result.openTime || "-",
              result.openPana || "-",
              result.openFigure || "-",
              result.closeTime || "-",
              result.closePana || "-",
              result.closeFigure || "-"
            )
          );
          setRows(formattedResults);
        } else {
          setRows([]);
        }
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    fetchResults();
  }, []);

  const isSameDigitOfLengthTwo = (number) => {
    const strNumber = number.toString();
    return strNumber.length === 2 && strNumber[0] === strNumber[1];
  };

  function createData(
    date,
    game,
    result,
    jodi,
    openTime,
    openPana,
    openFigure,
    closeTime,
    closePana,
    closeFigure
  ) {
    return {
      date,
      game,
      result,
      jodi,
      openTime,
      openPana,
      openFigure,
      closeTime,
      closePana,
      closeFigure,
    };
  }

  if (loading) return <div style={{ color: "orange" }}>Loading...</div>;
  if (error) return <div style={{ color: "red" }}>Error: {error.message}</div>;

  function removeLastCharacter(gameName) {
    const lastChar = gameName.slice(-1);
    return lastChar === "O" || lastChar === "C"
      ? gameName.slice(0, -1).trim()
      : gameName.trim();
  }

  const isSpecialJodi = (number) => {
    const strNumber = number.toString();
    if (strNumber.length !== 2) return false;

    const [firstDigit, secondDigit] = strNumber.split("").map(Number);

    // Check if both digits are the same or their absolute difference is 5
    return (
      firstDigit === secondDigit || Math.abs(firstDigit - secondDigit) === 5
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <TableContainer>
        <Table sx={{ maxWidth: 500 }} aria-label="simple table">
          <TableHead sx={{ background: "#1e2466" }}>
            <TableRow>
              {[
                "Date",
                "Game",
                "Result",
                "Jodi",
                "Open Time",
                "O.Pana",
                "O.Figure",
                "Close Time",
                "C.Pana",
                "C.Figure",
              ].map((header) => (
                <TableCell
                  key={header}
                  align="center"
                  style={{
                    border: "1px solid black",
                    whiteSpace: "nowrap",
                    padding: 1.5,
                    color: "#ffffff",
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={index}>
                <TableCell align="center" style={cellStyle}>
                  {row.date}
                </TableCell>
                <TableCell align="center" style={cellStyle}>
                  {removeLastCharacter(row.game)}
                </TableCell>
                <TableCell align="center" style={cellStyle}>
                  {row.result}
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    ...cellStyle,
                    background: "#80d8ff",
                    color: isSpecialJodi(row.jodi)
                      ? "red"
                      : row.jodi === "-"
                      ? ""
                      : "#000",
                  }}
                >
                  {row.jodi}
                </TableCell>

                <TableCell align="center" style={cellStyle}>
                  {row.openTime}
                </TableCell>
                <TableCell align="center" style={cellStyle}>
                  {row.openPana}
                </TableCell>
                <TableCell align="center" style={cellStyle}>
                  {row.openFigure}
                </TableCell>
                <TableCell align="center" style={cellStyle}>
                  {row.closeTime}
                </TableCell>
                <TableCell align="center" style={cellStyle}>
                  {row.closePana}
                </TableCell>
                <TableCell align="center" style={cellStyle}>
                  {row.closeFigure}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

const cellStyle = {
  border: "1px solid black",
  padding: 6,
  fontSize: "12px",
  fontWeight: "bold",
  whiteSpace: "nowrap",
};

export default ResultTable;
